import { CSSProperties, ReactNode } from "react";

import { ClassNameFormatter } from "@bem-react/classname";
import { GridLayoutItemProps } from "@multiweb/reactComponents";
import { TypedObject } from "@multiweb/types/react";
import { IDisposable } from "Global/Base/IDisposable";
import { IForm } from "UI/UI/UI/XGControls/IForm";

/**
 * Typ, ze kterého se generují třídy do sty.
 */
export type ClassNamesModifiersType = TypedObject<string | boolean>;

/**
 * Interface pro ItemRenderer.
 */
export interface IItemRenderer extends IDisposable {
    /** Properties pro GridLayoutItem vyčtené z elementu. */
    readonly gridItemProps: GridLayoutItemProps;
    /**
     * Obalující element Framu z formuláře. FormConverter obalí itemy elementem,
     * který má na sobě atributy týkající se GridLayoutu (colums, gap, ...)
     * */
    readonly element: HTMLElement;
    /**
     * Formulář, na kterém je element umístěn. Pomocí něj se dají zjistit
     * ExtendedProperties a Tags, které mohou ovlivnit vyrenderování itemu.
     */
    readonly ownerForm: IForm;
    /** Element z definice formuláře (List, Edit, GroupBox, ...) */
    readonly innerElement: HTMLElement;
    /** Výška itemu. */
    readonly innerElementHeight: number | string | undefined;
    /** Modifikátory pro className formater. */
    readonly classNameModifiers: TypedObject<string | boolean>;
    /** Formatter pro generování class names. */
    readonly classNames: ClassNameFormatter;
    /** Styly pro inner element wrapper. */
    readonly styles: CSSProperties;
    /** Klíč, který se použije pro item k odlišení od ostatních itemů renderovaných v poli. */
    readonly reactKey: string;

    /**
     * Volá se na incializaci pro každý ItemRenderer
     * */
    initialize(): void;

    /**
     * Vrací GridLayoutItem i s vnitřními komponentami.
     *
     * @returns Vrací GridLayoutItem
     */
    render(): ReactNode;

    /**
     * Vrací defaultní vnitřní komponenty GridLayoutMultiwebItem.
     *
     * @returns Vrací vnitřní komponenty GridLayoutMultiwebItem.
     */
    getMountedInnerElement(): ReactNode;
}

type Constructor<T> = new (...args: any[]) => T;
export type ItemRendererConstructor = Constructor<IItemRenderer>;
